export default __webpack_public_path__ + "static/media/bed-bread.0940e9f0.svg";